import { Template } from '@amzn/fire-tv-campaign-automation-service';
import { KatDropdown } from '@amzn/katal-react';
import { StyledDropdown } from 'src/components/general/StyledDropdown';
import { useSelection } from 'src/contexts/SelectionContext';
import { PropUtils } from 'src/utils/PropUtils';

interface TemplateSelectorProps {}

// ToDo: The list of applicable templates needs to be passed from CDK
const APPLICABLE_TEMPLATES: Template[] = [Template.FR_READY_ASSETS];
const TEMPLATE_OPTIONS = PropUtils.createOptionsFromEnumValues(APPLICABLE_TEMPLATES);

const TemplateSelector = ({}: TemplateSelectorProps) => {
  const { template, setTemplate } = useSelection();
  const handleTemplateChange = (event: KatDropdown.ChangeEvent) => {
    setTemplate(event.detail.value as Template);
  };

  return (
    <StyledDropdown
      onChange={handleTemplateChange}
      options={TEMPLATE_OPTIONS}
      label="Select Template"
      style={{ marginRight: '25px' }}
      value={template || Template.FR_READY_ASSETS}
    />
  );
};

export { TemplateSelector };
